import { Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import LoadingView from "components/LoadingView";
import ErrorView from "components/ErrorView";
import { useNavigate } from "react-router-dom";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import Div from "@jumbo/shared/Div";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import { GET_TAGS } from "app/utils/constants/paths";
import { ROUTES } from "app/utils/constants/routeConstants";

const TagsSection = () => {
  const navigate = useNavigate();
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch tags data on component mount
  useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true);
        const response = await jwtAuthAxios.get(`${GET_TAGS}?size=50&page=0`);
        const data = response.data;
        setTags(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTags();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sx={{ textAlign: "center" }}>
        <Typography
          variant="h2"
          fontWeight={700}
          color="text.primary"
          fontSize={{ xs: "28px", md: "40px" }}
        >
          Explore topics
        </Typography>
      </Grid>
      {loading ? (
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <LoadingView message="Loading tags..." />
        </Grid>
      ) : error ? (
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <ErrorView
            error={error}
            onBack={() => navigate(-1)}
            backButtonLabel="Back"
          />
        </Grid>
      ) : tags.length === 0 ? (
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Typography variant="body1">No tags available</Typography>
        </Grid>
      ) : (
        tags
          .filter((tag) => tag.active)
          .map((tag) => (
            <Grid item xs={12} sm={6} lg={3} key={tag.id}>
              <JumboCardQuick
                // bgColor={"#B8E2FF"}
                sx={{
                  height: "100%",
                  "& .MuiCardContent-root": {
                    display: "flex",
                    height: "100%",
                    justifyContent: "center",
                  },
                  borderRadius: 2,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#F5F7FA",
                  },
                }}
                onClick={() =>
                  navigate(
                    `${ROUTES.ALGOS_AND_DS}?size=25&page=1&sort=id%2Casc&Tags=${tag.name}`
                  )
                }
              >
                <Div sx={{ display: "flex", alignItems: "center" }}>
                  {/* {tag.image && (
                      <img
                        src={`data:${tag.imagecontenttype};base64,${tag.image}`}
                        alt={tag.name}
                        style={{
                          width: 40,
                          height: 40,
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    )} */}

                  <Typography variant="h4" mb={0}>
                    {tag.name}
                  </Typography>
                </Div>
              </JumboCardQuick>
            </Grid>
          ))
      )}
    </Grid>
  );
};

export default TagsSection;
